import React from 'react';
import {
  HomefieldIconArrowLeft,
  HomefieldIconSearch,
  HomefieldIconSignCancel,
} from '@dsg-tech/homefield-react-icons';
import { KEY_CODES } from 'utility/constants';
import { useAppDispatch } from 'store/store';
import { resetSelectedCategory } from 'store/slices/progressiveHeader';
import MainLogo from 'components/common/MainLogo/MainLogo';
import './ProgressiveHeader.scss';

interface HeaderProps {
  storeIdentifierName: string;
  showL1Links: boolean;
  showL2Links: boolean;
  setShowDrawer: () => void;
  navigateBackToL0Menu: () => void;
  handleSayt: () => void;
}

const Header = ({
  storeIdentifierName,
  showL1Links,
  showL2Links,
  setShowDrawer,
  navigateBackToL0Menu,
  handleSayt,
}: HeaderProps) => {
  const dispatch = useAppDispatch();

  let logoLabel = '';
  switch (storeIdentifierName) {
    case 'gg':
      logoLabel = 'Golf Galaxy Logo';
      break;
    case 'pl':
      logoLabel = 'Public Lands Logo';
      break;
    default:
      logoLabel = "Dick's Sporting Goods Logo";
  }

  return (
    <div
      className="header-container hmf-display-flex hmf-justify-content-between hmf-align-items-center hmf-py-xs hmf-px-xxs hmf-mt-xlg-xl hmf-p-xlg-s hmf-mx-xlg-m"
      id="headerContainerProgressiveTaxo">
      <button
        data-testid="headerLogoProgressiveTaxo"
        id="headerLogoProgressiveTaxo"
        className="header-logo-container hmf-pl-xxs hmf-pl-xlg-0"
        onClick={() => {
          setShowDrawer();
          document.body.style.overflow = 'scroll';
        }}
        type="button"
        onKeyDown={(event) => {
          if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
            setShowDrawer();
            document.body.style.overflow = 'scroll';
          }
        }}
        tabIndex={0}
        aria-label={logoLabel}>
        <MainLogo variant="dark" sizes="small" />
      </button>
      {(showL1Links || showL2Links) && (
        <div
          className="hmf-display-flex hmf-align-items-center hmf-w-100"
          id="sayTContainerProgressiveTaxo">
          <button
            data-testid="backButtonProgressiveTaxo"
            className="hmf-p-xxs back-button hmf-display-block hmf-display-xlg-none"
            onClick={() => navigateBackToL0Menu()}
            type="button"
            onKeyDown={(event) => {
              if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
                navigateBackToL0Menu();
              }
            }}
            tabIndex={0}
            aria-label="Navigate back">
            <HomefieldIconArrowLeft width="32" height="32" />
          </button>
          <button
            className="sayt-button hmf-pl-s hmf-mx-xxxs hmf-display-flex hmf-display-lg-none hmf-align-items-center hmf-justify-content-space-between"
            type="button"
            onClick={() => handleSayt()}
            onKeyDown={(event) => {
              if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
                handleSayt();
              }
            }}
            tabIndex={0}
            aria-label="Search">
            <HomefieldIconSearch width="16px" height="16px" />
            <div className="hmf-body-l hmf-pl-xxxs label-secondary-subtle-static">Search</div>
          </button>
        </div>
      )}
      <div className="hmf-display-flex hmf-align-items-center">
        <button
          className="search-icon-container hmf-p-xxs hmf-display-block hmf-display-lg-none"
          data-testid="searchIconProgressiveTaxo"
          id="searchIconProgressiveTaxo"
          type="button"
          aria-label="Search icon"
          onClick={() => handleSayt()}
          onKeyDown={(event) => {
            if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
              handleSayt();
            }
          }}
          tabIndex={0}>
          <HomefieldIconSearch width="32" height="32" />
        </button>
        <button
          className="close-icon-container hmf-p-xxs"
          type="button"
          aria-label="Close menu"
          onClick={() => {
            setShowDrawer();
            dispatch(resetSelectedCategory());
            document.body.style.overflow = 'scroll';
          }}
          onKeyDown={(event) => {
            if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
              setShowDrawer();
              dispatch(resetSelectedCategory());
              document.body.style.overflow = 'scroll';
            }
          }}
          tabIndex={0}>
          <HomefieldIconSignCancel width="32" height="32" />
        </button>
      </div>
    </div>
  );
};

export default Header;
